<ion-header>
  <ion-toolbar class="header">
    <ion-title class="title-modal">{{
      "version-update.title" | translate
    }}</ion-title>
    @if (!isRequired) {
    <ion-buttons slot="end">
      <ion-button (click)="dismiss()">
        <ion-icon name="close" class="close-icon"></ion-icon>
      </ion-button>
    </ion-buttons>
    }
  </ion-toolbar>
</ion-header>

<ion-content class="ion-padding">
  <div class="version-update-content">
    <div class="update-icon">
      <ion-icon name="cloud-download-outline"></ion-icon>
    </div>

    <h2 class="update-title">
      {{
        isRequired
          ? ("version-update.required-title" | translate)
          : ("version-update.optional-title" | translate)
      }}
    </h2>

    <div class="version-info">
      <div class="version-item">
        <span class="label"
          >{{ "version-update.current-version" | translate }}:</span
        >
        <span class="value">{{ currentVersion }}</span>
      </div>
      <div class="version-item">
        <span class="label"
          >{{ "version-update.latest-version" | translate }}:</span
        >
        <span class="value latest">{{ latestVersion }}</span>
      </div>
    </div>

    @if (releaseNotes) {
    <div class="release-notes">
      <h3>{{ "version-update.release-notes" | translate }}</h3>
      <p>{{ releaseNotes }}</p>
    </div>
    } @if (isRequired) {
    <div class="required-message">
      <ion-icon name="warning"></ion-icon>
      <p>{{ "version-update.required-message" | translate }}</p>
    </div>
    }

    <div class="action-buttons">
      <app-main-button
        [label]="'version-update.update-button'"
        (clicked)="updateApp()"
      />

      @if (!isRequired) {
      <app-secondary-button
        [label]="'version-update.later-button'"
        (clicked)="dismiss()"
      />
      }
    </div>
  </div>
</ion-content>
